import { baseThemeValues } from 'constants/common';
import { componentRowActionsTheme } from 'routes/pages/AuthorizedStack/ThemeEditor/Editor/ComponentRowActions/theme';
import { componentSidebarTheme } from 'routes/pages/AuthorizedStack/ThemeEditor/Editor/ComponentSidebar/theme';
import { editorHeaderTheme } from 'routes/pages/AuthorizedStack/ThemeEditor/Editor/Header/theme';
import { previewHighlightTheme } from 'routes/pages/AuthorizedStack/ThemeEditor/Editor/PreviewHighlight/theme';
import { editorSidebarTheme } from 'routes/pages/AuthorizedStack/ThemeEditor/Editor/Sidebar/theme';

export const themeEditorTheme = {
  componentRowActions: componentRowActionsTheme,
  componentSidebar: componentSidebarTheme,
  header: editorHeaderTheme,
  hostedFieldsBg: 'palette.tertiary.95',
  previewHighlight: previewHighlightTheme,
  settingsHeader: {
    bg: 'palette.surface.2',
    borderColor: 'palette.neutral.5',
    borderWidth: '1px',
    boxShadow: 'palette.black:0.1',
    settingName: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '14px',
      fontWeight: 600,
      text: 'palette.neutral.90',
    },
  },
  sidebar: editorSidebarTheme,
};
